import { wtUserApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import {
  ApiResponse,
  adaptApiToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

import type { InternalUserProfileDto } from './dto';
import { mapInternalUserProfilesListDtoToModel } from './mappers';
import type { GetUsersByRoleAndNameParams, InternalUserProfile } from './models';

export const getUsersByRoleAndName = async (
  params: GetUsersByRoleAndNameParams,
): Promise<GenericResponse<ApiResponse<InternalUserProfile[]>>> => {
  try {
    const response = await wtUserApi.get<InternalUserProfileDto[]>(
      '/management/users/filter',
      {
        params,
      },
    );

    const mappedData = mapInternalUserProfilesListDtoToModel(response.data ?? []);

    const mappedResponse: ApiResponse<InternalUserProfile[]> = {
      data: mappedData,
      status: 'OK',
      message: 'OK',
      pagination: null,
    };

    return adaptApiToGenericResponse(mappedResponse, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al obtener datos de Asesor',
    );
  }
};
